// const phone = (v) => {
// 	return 	!v || v === '' ||
// 			/^(\+[0-9]{1,4} ?)?[0-9]{2} [0-9]{3}[ -][0-9]{2}[ -][0-9]{2}$/.test(v) ||
// 			/^(\+[0-9]{1,4} ?)?[0-9]{3}[ -]?[0-9]{3}[ -]?[0-9]{3}$/.test(v) ||
// 			/^(\+[0-9]{1,4} ?)?[0-9]{3}[ -]?[0-9]{2}[ -]?[0-9]{2}[ -]?[0-9]{2}$/.test(v);
// }

const phone = v => {
  return !v || v === "" || /^(\+[0-9]{1,4} ?)?[0-9 ]{6,}$/.test(v);
};

export default phone;
